<template>
  <!-- modal cadastro -->
  <b-modal id="modal-cadastrar" dialog-class="modal-live" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title" v-if="isEdicao">Editar live</h5>
      <h5 class="modal-title" v-else>Cadastrar live</h5>

      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form enctype="multipart/form-data">
      <h6><i class="fas fa-key"></i> Dados da Live <span v-if="isEdicao"> #{{ live.id}} </span> </h6>
      <div class="row">
        <div class="col-12 col-md-12">
          <form-group id="nomeLive"  label="Nome *" :text="{ required: 'Obrigatório informar o nome da live' }" :field="$v.live.live">
            <input type="text" class="form-control" id="nome" placeholder="" v-model="live.live" />
          </form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12">
          <form-group id="urlVideo"  label="URL do Vídeo (Formato: https://www.youtube.com/embed/...) *" :text="{ required: 'Obrigatório informar a url do video', regexVideo: 'Formato inválido' }" :field="$v.live.url_video">
            <input type="text" class="form-control" id="video" placeholder="https://www.youtube.com/embed/C4NL56kfk24" v-model="live.url_video" />
          </form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12">
          <form-group id="nomeProfessor"  label="Professor *" :text="{ required: 'Obrigatório informar o nome do professor' }" :field="$v.live.professor">
            <input type="text" class="form-control" id="professor" placeholder="" v-model="live.professor" />
          </form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-6 col-md-6">
          <form-group id="datahoraPrevistaInicio"  label="Data Prevista de Início *" :text="{ required: 'Obrigatório informar a previsão de início' }" :field="$v.live.datahora_prevista_inicio">
            <input v-if="isSafari" type="datetime-local" v-mask="['##/##/#### ##:##']" class="form-control" id="datahora_prevista_inicio" placeholder="dd/mm/aaaa --:--" v-model="live.datahora_prevista_inicio" />
            <input v-else type="datetime-local" class="form-control" id="datahora_prevista_inicio" placeholder="dd/mm/aaaa --:--" v-model="live.datahora_prevista_inicio" />
          </form-group>
        </div>
        <div class="col-6 col-md-6">
          <form-group id="datahoraPrevistaFim"  label="Data Prevista de Encerramento *" :text="{ required: 'Obrigatório informar a previsão de encerramento' }" :field="$v.live.datahora_prevista_fim">
            <input v-if="isSafari" type="datetime-local" v-mask="['##/##/#### ##:##']" class="form-control" id="datahora_prevista_fim" placeholder="dd/mm/aaaa --:--" v-model="live.datahora_prevista_fim" />
            <input v-else type="datetime-local" class="form-control" id="datahora_prevista_fim" placeholder="dd/mm/aaaa --:--" v-model="live.datahora_prevista_fim" />
          </form-group>
        </div>
      </div>

      <div class="row" v-if="!isB2B">
        <div class="col-12 col-md-6" v-if="!isEdicao">
          <form-group id="empresas" label="Empresas" :field="$v.live.empresas_ids">
            <multiselect v-model="arrayEmpresasIds" :options="empresas" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                         placeholder="Selecione uma empresa" label="empresa" track-by="id" select-label="Selecionar empresa" deselect-label="Remover empresa"
                         selected-label="Empresa selecionada" :preselect-first="false" :block-keys="['Tab','Enter']">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} empresas selecionados</span>
              </template>
            </multiselect>
          </form-group>
        </div>

        <div class="col-12 col-md-6" v-if="isEdicao">
          <form-group id="empresasEditar" label="Empresas" :field="$v.live.empresa_id">
            <multiselect v-model="live.empresas" :options="empresas" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                         placeholder="Selecione uma empresa" label="empresa" track-by="id" select-label="Selecionar empresa" deselect-label="Remover empresa"
                         selected-label="Empresa selecionada" :preselect-first="false" :block-keys="['Tab','Enter']">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} empresas selecionados</span>
              </template>
            </multiselect>
          </form-group>
        </div>
      </div>

      <div class="row">
       <div class="col-12 col-md-12">
          <div class="form-group">
            <label>Comentário</label>
            <textarea class="form-control" rows="3" v-model="live.observacao"></textarea>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="editarLive" v-if="isEdicao">Salvar</button>
          <button class="btn btn-primary mr-3" type="button" @click="cadastrarLive" v-else>Cadastrar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import LiveAPI from '@/api/live-api'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'
import { required, helpers } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import DateUtils, { DateConstants } from '@/core/util/date-utils'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import EmpresaUtils from '@/core/util/empresa-utils'
import moment from 'moment'

const regexVideo = helpers.regex('regexVideo', /https:\/\/www.youtube.com\/embed\/[\w\-_]+/)

export default {
  name: 'ModalCadastroLive',
  components: { FormGroup, Multiselect },
  props: {
    liveEdicao: Object,
    empresas: Array
  },
  data () {
    return {
      live: {
        live: '',
        datahora_prevista_inicio: null,
        datahora_prevista_fim: null,
        url_video: '',
        professor: '',
        observacao: '',
        empresas_ids: [],
        empresa_id: '',
        empresas: []
      },
      arrayEmpresasIds: EmpresaUtils.getEmpresa()
    }
  },

  computed: {
    isSafari: function () {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('safari') !== -1) {
        if (ua.indexOf('chrome') > -1) {
          return false
        } else {
          return true
        }
      }
      return false
    },

    isEdicao: function () {
      return this.liveEdicao && this.liveEdicao.id > 0
    },

    isB2B: function () {
      return (EmpresaUtils.getEmpresa().b2b === 1)
    },

    listaEmpresasIds: function () {
      let arrayEmpresaId = []
      if (Array.isArray(this.arrayEmpresasIds)) {
        this.arrayEmpresasIds.map(empresa => {
          arrayEmpresaId.push(empresa.id)
        })
      } else {
        arrayEmpresaId.push(this.arrayEmpresasIds.id)
      }
      return arrayEmpresaId
    }

  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()

      if (this.liveEdicao) {
        this.live = Object.assign({}, this.liveEdicao)
        if (this.isSafari) {
          this.live.datahora_prevista_inicio = moment(this.liveEdicao.datahora_prevista_inicio).format('DD/MM/YYYY HH:mm')
          this.live.datahora_prevista_fim = moment(this.liveEdicao.datahora_prevista_fim).format('DD/MM/YYYY HH:mm')
        } else {
          this.live.datahora_prevista_inicio = this.liveEdicao.datahora_prevista_inicio ? DateUtils.formatDate(DateUtils.parse(this.liveEdicao.datahora_prevista_inicio), DateConstants.DD_MM_YYYY_T) : null
          this.live.datahora_prevista_fim = this.liveEdicao.datahora_prevista_fim ? DateUtils.formatDate(DateUtils.parse(this.liveEdicao.datahora_prevista_fim), DateConstants.DD_MM_YYYY_T) : null
        }
      } else {
        this.live = {
          live: '',
          datahora_prevista_inicio: null,
          datahora_prevista_fim: null,
          url_video: '',
          professor: '',
          observacao: '',
          empresas_ids: []
        }
        this.arrayEmpresasIds = EmpresaUtils.getEmpresa()
      }
    })
  },

  validations: {
    live: {
      live: { required },
      datahora_prevista_inicio: { required },
      datahora_prevista_fim: { required },
      url_video: { required, regexVideo },
      professor: { required },
      observacao: { },
      empresas_ids: { },
      empresa_id: { }
    }
  },

  methods: {

    show: function () {
      this.$bvModal.show('modal-cadastrar')
    },

    cadastrarLive: function () {
      this.$v.live.$touch()
      if (!this.$v.live.$invalid) {
        const loader = this.$loading.show()

        if (this.isB2B) {
          this.live.empresas_ids.push(EmpresaUtils.getEmpresa().id)
        } else {
          this.live.empresas_ids = this.listaEmpresasIds
        }
        let live = this.live
        if (this.isSafari) {
          live.datahora_prevista_fim = moment(this.live.datahora_prevista_fim, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
          live.datahora_prevista_inicio = moment(this.live.datahora_prevista_inicio, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        }

        LiveAPI.salvar(live, EmpresaUtils.getEmpresa().id
        ).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Live criada com sucesso'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('liveSalva', this.live)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    editarLive: function () {
      this.$v.live.$touch()
      if (!this.$v.live.$invalid) {
        const loader = this.$loading.show()
        let live = this.live
        if (this.isSafari) {
          live.datahora_prevista_fim = moment(this.live.datahora_prevista_fim, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
          live.datahora_prevista_inicio = moment(this.live.datahora_prevista_inicio, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        }
        LiveAPI.editar(live).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Live atualizada com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('liveSalva', this.live)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>

<style>
</style>
